module.exports = __webpack_public_path__ + "static/media/002.ed0e21ef.jpg";